import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'lib-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss']
})
export class SlideComponent implements OnInit {
  @Input() row: any;
  @Input() images: any;
  @Input() coordinates: any;
  @Input() max: any;
  @Input() config: {
    width: number,
    height: number
  } = {
    width: 0,
    height: 0
  };

  heatMapWidth = 0;
  heatMapHeight = 0;
  @ViewChild('parent') parent: ElementRef | undefined;
  // @ts-ignore
  @ViewChild('rImg') rImg: ElementRef;
  // @ts-ignore
  @ViewChild('lImg') lImg: ElementRef;

  // @ts-ignore
  @ViewChild('heatmapWrp') heatmapWrp: ElementRef;

  constructor() {
  }

  parentWidth = 0;

  ngOnInit(): void {

  }
}
